'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _JPlayerFactory = require('./jplayer/JPlayerFactory');

var _JPlayerFactory2 = _interopRequireDefault(_JPlayerFactory);

var _HlsJsPlayerFactory = require('./hlsjs/HlsJsPlayerFactory');

var _HlsJsPlayerFactory2 = _interopRequireDefault(_HlsJsPlayerFactory);

var _WindowsMediaPlayerFactory = require('./wmp/WindowsMediaPlayerFactory');

var _WindowsMediaPlayerFactory2 = _interopRequireDefault(_WindowsMediaPlayerFactory);

var _HowlerFactory = require('./howler/HowlerFactory');

var _HowlerFactory2 = _interopRequireDefault(_HowlerFactory);

var _players = require('./constants/players');

var _players2 = _interopRequireDefault(_players);

var _debugger = require('../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayerCache = function () {
  function PlayerCache(configuration) {
    var _cache;

    var queueSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    (0, _classCallCheck3.default)(this, PlayerCache);

    this.queueSize = queueSize;
    this.cache = (_cache = {}, (0, _defineProperty3.default)(_cache, _players2.default.jplayer, {
      queue: [],
      factory: new _JPlayerFactory2.default()
    }), (0, _defineProperty3.default)(_cache, _players2.default.hlsjs, {
      queue: [],
      factory: new _HlsJsPlayerFactory2.default((0, _get2.default)(configuration, 'resources.hlsjs'))
    }), (0, _defineProperty3.default)(_cache, _players2.default.wmp, {
      queue: [],
      factory: new _WindowsMediaPlayerFactory2.default((0, _get2.default)(configuration, 'blankMp3Url'))
    }), _cache);

    if (configuration.isHowlerEnabled) {
      this.cache[_players2.default.howler] = {
        queue: [],
        factory: new _HowlerFactory2.default((0, _get2.default)(configuration, 'blankMp3Url'))
      };
    }

    // Load the cache when PlayerCache is instantiated.
    this._load();
  }

  (0, _createClass3.default)(PlayerCache, [{
    key: 'setPlayer',
    value: function setPlayer(name) {
      var config = this.cache[name];
      if (!config) {
        return;
      }

      if (config.queue.length >= this.queueSize) {
        return;
      }
      try {
        var player = config.factory.createPlayer();
        if (!player) {
          return;
        }
        config.queue.push(player);
      } catch (ex) {
        _debugger2.default.log('Could not create player ' + name, ex);
      }
    }
  }, {
    key: 'getPlayer',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
        var config, player;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.cache[name];

                if (config) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', null);

              case 3:
                player = config.queue.shift();

                if (player) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', null);

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return player.init();

              case 9:
                return _context.abrupt('return', player);

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                _debugger2.default.log('Could not initialize cached player ' + player, _context.t0);
                return _context.abrupt('return', null);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function getPlayer(_x2) {
        return _ref.apply(this, arguments);
      }

      return getPlayer;
    }()
  }, {
    key: '_load',
    value: function _load() {
      var _this = this;

      (0, _forEach2.default)(this.cache, function (playerConfig, playerName) {
        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < _this.queueSize; i++) {
          _this.setPlayer(playerName);
        }
      });
    }
  }, {
    key: 'allPlayers',
    get: function get() {
      return (0, _reduce2.default)(this.cache, function (allPlayers, playerConfig) {
        return allPlayers.concat(playerConfig.queue);
      }, []);
    }
  }]);
  return PlayerCache;
}(); /* eslint-disable no-underscore-dangle */


exports.default = PlayerCache;
//# sourceMappingURL=PlayerCache.js.map